import { render, staticRenderFns } from "./CountdownBackground.vue?vue&type=template&id=543bc742&scoped=true&"
import script from "./CountdownBackground.vue?vue&type=script&lang=js&"
export * from "./CountdownBackground.vue?vue&type=script&lang=js&"
import style0 from "./CountdownBackground.vue?vue&type=style&index=0&id=543bc742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543bc742",
  null
  
)

export default component.exports